export const primaryColor = '#1da57a';

export const Theme = {
  colors: {
    primary: primaryColor,
    sidebarBg: '#1e2a31',
    menuBg: '#22313a',
    menuSubBg: '#233139',
    menuTriggerBg: '#22313a',
    menuActiveItemBg: 'rgba(255, 255, 255, 0.05)',
    menuHoverItemBg: primaryColor,
    white: '#ffffff',
  },
};
